const brandTrigger = {
  brandTrigger: document.querySelectorAll(
    ".jsBrandTrigger"
  ) as NodeListOf<HTMLElement>,
  brandBody: document.querySelectorAll(
    ".jsBrandBody"
  ) as NodeListOf<HTMLElement>,

  init() {
    this.setTriggers();
  },
  setTriggers() {
    this.brandTrigger.forEach((item, index) => {
      item.addEventListener("click", (e) => {
        e.preventDefault();
        this.removeClass();
        item.classList.add("activeClass");
        this.brandBody[index].classList.add("activeClass");
      });
    });
  },
  removeClass() {
    this.brandBody.forEach((item) => {
      item.classList.remove("activeClass");
    });
    this.brandTrigger.forEach((item) => {
        item.classList.remove("activeClass");
      });
  },
};

export default brandTrigger;
